import React from 'react';
import UpperHeader from '../../components/header/UpperHeader';
import Header from '../../components/header/Header';
import Title from '../../components/title/Title';
import Subtitle from '../../components/subtitle/Subtitle';
import Paragraph from '../../components/paragraph/Paragraph';
import Image from '../../components/image/Image';
import Button from '../../components/button/Button';
import Footer from '../../components/footer/Footer';

const Project: React.FC = () => {
    return (
        <div>
        <UpperHeader/>

        <Header
            pageTitle='研究内容'/>

        <Title
            text='2026・2027年度研究テーマ'/>

        <Subtitle
            text='バイオフィルムによる海洋プラスチック分解' />

        <Image
            src='pages/about_us/Project/oceanPlastic.webp'
            alt='海に漂うビニール袋と魚の群れ'
            caption='海に流出したプラスチックは、砕けながら生態系の中を巡っていきます'
            width={500}
            height={375}
            borderRadius={0}
            margin='0px'
        />

        <Paragraph
            text='　私たちの生活に欠かせないプラスチックですが、不適切に廃棄されたプラスチックは毎年数百万トン規模で海へ流れ込み、その多くは自然界でほとんど分解されません。ペットボトルの原料であるPET（ポリエチレンテレフタラート）は分解に最大450年かかるとも言われ、砕けてマイクロプラスチックとなり、食物連鎖を通じて私たちの体にも戻ってきます。'/>
        <Paragraph
            text='　この問題に対し、世界ではPETを分解する酵素（PETaseやLCC）を遺伝子工学で強化する研究が主流です。しかしその多くは、プラスチックを砕き、約70℃の高温で精製した酵素を大量に使う「工場のタンクの中」の技術で、海に散らばったプラスチックにそのまま使えるわけではありません。'/>
        <Paragraph
            text='　そこで私たちが着目したのが、微生物のバイオフィルム形成能力です。バイオフィルムとは、微生物が膜状に集まった集合体で、排水溝のぬめりや歯垢も同じ現象です。これをプラスチックの表面でつくらせ、菌が生み出すPETaseを分解対象のすぐ目の前に集中させることで、酵素とPETの接触面積を増やし、分解効率を高めようというアイデアです。このアイデア自体は少数の先行研究があるものの、バイオフィルム内での細菌の動態を制御することで、より効率的に分解できる、あるいは、より環境中で安全に使用できることを目指して研究を進めています。'/>
        <Paragraph
            text='　さらに、無秩序にバイオフィルムが形成すると在来の生態系に悪影響を及ぼしかねないことから、プラスチック表面でのみ増殖する細菌・バイオフィルムを作れないか検討中です。'/>

        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Button
                label='2024・2025年度の研究テーマはこちら'
                textColor='#007AFF'
                backgroundColor='#FFFFFF'
                link='/about/project2025'/>
            <Button
                label='2023年度の研究テーマはこちら'
                textColor='#D20000'
                backgroundColor='#FFFFFF'
                link='/about/project2023'/>
        </div>

        <Footer/>

        </div>
    );
}

export default Project;
